export default __webpack_public_path__ + "static/media/Mixed Veg Juice - proportioned_170.51c67bbe.jpg";